



















import CareTeamDashboard from '@/components/care-team-dashboard/CareTeamDashboard.vue'
import ExecDashboard from '@/components/exec-dashboard/ExecDashboard.vue'
import NursingHomeDashboard from '@/components/nursing-home-dashboard/NursingHomeDashboard.vue'
import { mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { AppGetterNames } from '@/store/modules/app/keys'

export default {
  components: {
    CareTeamDashboard,
    ExecDashboard,
  },
  data() {
    return {
      role: true,
      selectedScreen: 'careteam',
      dashboardOptions: [
        { text: 'Care Team', value: 'careteam' },
        // { text: 'Nursing Home', value: 'nursinghome' },
        { text: 'Exec', value: 'exec' },
      ],
    }
  },
  computed: {
    ...mapGetters(ModuleNames.app, {
      isAdminUser: AppGetterNames.isAdminUser,
      isExecUser: AppGetterNames.isExecUser,
      isCareTeamUser: AppGetterNames.isCareTeamUser,
      // isNursingHomeUser: AppGetterNames.isNursingHomeUser
    }),
  },
}
